import * as React from "react"

const Line2 = React.forwardRef((props, pathRef) => {
        return (
            <svg
                id={"line-2"}
                width={2}
                height={500}
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    ref={pathRef}
                    className="line-2"
                    d="m.5.998 1 500"
                    strokeDashoffset={props.normalizedPosition }
                    strokeDasharray={props.pathLength}
                    strokeWidth={2}
                    stroke="#DEDDE2"
                />
            </svg>
        )
    }
)

export default Line2
